import { SOURCE_CREATE } from 'store/eventConstants';
import { BROADCAST_CREATE_CONTENT_SOURCE_STATUS } from '@shoflo/studio-redux/actions/source/types';
import setSourceUploadStatus from '@shoflo/studio-redux/actions/source/setSourceUploadStatus';
import { UPLOADED } from 'constants/SourceUploadStatus';
import { getSignedUrl } from 'utils/broadcastSourceHelper';
import { withCurrentParams } from 'actions/utils';

/**
 * It updates the signed url for the source modified by {@link createContentSource} which will be fetched using s3 proxy once upload is successful.
 * Additionally, it hides the UploadStatusPane and fires a message on socket to notify other directors about the successful creation of a new source
 * @param source - The actual source media which was uploaded and for which the state should be updated
 */
const createContentSourceStatus = source => {
  return withCurrentParams((dispatch, { broadcastId }, getState, socket) => {
    const {
      meeting: { attendeeResponse }
    } = getState();
    const isInitializing = false;
    const action = {
      type: BROADCAST_CREATE_CONTENT_SOURCE_STATUS,
      request: async apiClient => {
        const { title: fileName = '' } = source || {};
        let result = await getSignedUrl(source, apiClient, true);
        dispatch(setSourceUploadStatus(fileName, UPLOADED));
        socket.emit(SOURCE_CREATE, {
          broadcastId,
          notifyingDirector:
            attendeeResponse && attendeeResponse.Attendee.AttendeeId
        });
        return {
          ...result,
          isInitializing
        };
      }
    };
    dispatch(action);
  });
};

export default createContentSourceStatus;
